var _circle, _path, _path2, _path3, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF1C29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7447 4.50284C34.3378 3.05162 41.8003 4.81552 47.7274 8.8405C53.6544 12.8655 58.0459 19.1516 59.4972 26.7447C60.9484 34.3378 59.1845 41.8003 55.1595 47.7274C51.1345 53.6544 44.8484 58.0459 37.2553 59.4972C29.6622 60.9484 22.1997 59.1845 16.2726 55.1595C10.3456 51.1345 5.95405 44.8484 4.50284 37.2553C3.05162 29.6622 4.81552 22.1997 8.8405 16.2726C12.8655 10.3456 19.1516 5.95405 26.7447 4.50284Z",
    fill: "#1C1C11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.375 32C57.375 46.0142 46.0142 57.375 32 57.375C17.9858 57.375 6.625 46.0142 6.625 32C6.625 17.9858 17.9858 6.625 32 6.625C46.0142 6.625 57.375 17.9858 57.375 32Z",
    fill: "url(#paint0_linear_4916_211388)",
    stroke: "#BA001D",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.856 35.4701C47.5483 31.4181 56 44.7372 56 31.6665C56 18.5959 45.2548 8 32 8C18.7452 8 8 18.5959 8 31.6665C8 44.7372 14.1638 39.522 30.856 35.4701Z",
    fill: "url(#paint1_linear_4916_211388)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4916_211388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 54C44.1503 54 54 44.1503 54 32C54 19.8497 44.1503 10 32 10C19.8497 10 10 19.8497 10 32C10 44.1503 19.8497 54 32 54Z",
    stroke: "url(#paint2_linear_4916_211388)",
    strokeWidth: 0.465371
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4916_211388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3407 23.1612C40.622 23.4425 40.7801 23.824 40.7801 24.2218C40.7801 24.6197 40.622 25.0012 40.3407 25.2825L33.6232 32L40.3407 38.7175C40.622 38.9988 40.7801 39.3803 40.7801 39.7782C40.7801 40.176 40.622 40.5575 40.3407 40.8388C40.0594 41.1201 39.6779 41.2782 39.2801 41.2782C38.8822 41.2782 38.5007 41.1201 38.2194 40.8388L31.5019 34.1213L24.7844 40.8388C24.5031 41.1201 24.1215 41.2782 23.7237 41.2782C23.3259 41.2782 22.9444 41.1201 22.6631 40.8388C22.3817 40.5575 22.2237 40.176 22.2237 39.7782C22.2237 39.3803 22.3817 38.9988 22.6631 38.7175L29.3806 32L22.6631 25.2825C22.3817 25.0012 22.2237 24.6197 22.2237 24.2218C22.2237 23.824 22.3817 23.4425 22.6631 23.1612C22.9444 22.8799 23.3259 22.7218 23.7237 22.7218C24.1215 22.7218 24.5031 22.8799 24.7844 23.1612L31.5019 29.8787L38.2194 23.1612C38.5007 22.8799 38.8822 22.7218 39.2801 22.7218C39.6779 22.7218 40.0594 22.8799 40.3407 23.1612Z",
    fill: "url(#paint3_linear_4916_211388)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4916_211388",
    x: 9.53294,
    y: 9.53465,
    width: 44.9341,
    height: 44.9307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.116343,
    result: "effect1_foregroundBlur_4916_211388"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_211388",
    x1: 32,
    y1: 58,
    x2: 48.6588,
    y2: 12.0379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C190D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA6050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4916_211388",
    x1: 32,
    y1: 8,
    x2: 32,
    y2: 26.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4916_211388",
    x1: -0.451857,
    y1: 1.37941,
    x2: 69.6677,
    y2: 46.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100982,
    stopColor: "white",
    stopOpacity: 0.607599
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194134,
    stopColor: "white",
    stopOpacity: 0.728666
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281272,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741712,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4916_211388",
    x1: 27.0091,
    y1: 27.4699,
    x2: 40.3594,
    y2: 40.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4916_211388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(15.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.b13cf50e6929e7e523554363cb55316a.svg";
export { ForwardRef as ReactComponent };